module.exports = __webpack_public_path__ + "static/img/bg_12.0586d24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_12.jpg
// module id = xyfj
// module chunks = 1